export const PROD_URL = "https://piawaindonesia.id";
export const DEV_URL = "http://localhost:8000";
